import React from 'react'
import { Route } from 'react-router-dom'
import PropTypes from 'prop-types'
import ACL from '@components/ACL'
import AccessDenied from '@components/Error/AccessDenied'

function ProtectedRoute ({ roles, path, component }) {
  return (
    <ACL roles={roles}>
      {allowed => {
        return (
          <Route path={path} component={allowed ? component : AccessDenied} />
        )
      }}
    </ACL>
  )
}

ProtectedRoute.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  path: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired
}

export default ProtectedRoute
